import { useRef, ChangeEvent, KeyboardEvent } from "react";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import { searchFormString, searchInputFormString, searchFieldWidth, searchLabelStyle } from "src/components/common/common";

interface Props {
    label: string;
    value: string;
    className?: string;
    wrapperOption?: {
        wrapperStyle?: string;
        titleStyle?: string;
        inputStyle?: string;
    };
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
    initValue?: () => void;
}

export const SearchInputForm = (props: Props) => {
    const {
        label,
        value,
        className = "",
        wrapperOption = {
            wrapperStyle: searchFieldWidth,
            titleStyle: searchLabelStyle,
            inputStyle: searchInputFormString,
        },
        onChange = () => { console.log("SearchInputForm onChange"); },
        onKeyDown = () => {},
        initValue = () => { console.log("searchInputForm initValue"); },
    } = props;

    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div className={`${searchFormString} ${wrapperOption?.wrapperStyle || searchFieldWidth} ${className}`}>
            <div
                className="flex items-center h-full gap-[8px] rounded-[6px] relative cursor-pointer"
                onClick={() => {
                    initValue();
                    inputRef.current?.focus();
                }}
            >
                <p className={wrapperOption?.titleStyle || searchLabelStyle}>{label}</p>
                <div className="relative">
                    <input
                        ref={inputRef}
                        className={`${wrapperOption?.inputStyle || searchInputFormString}`}
                        value={value}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                    />
                    <XButtonForm
                        onClick={() => {
                            initValue();
                            inputRef.current?.focus();
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
